import { useEffect, useState } from 'react';
import { GroupService } from '../../Services/GroupService';
import { WebApiMemberDtoMemberListResultDto, WebApiServicesDataTransferObjectsGroupServiceGroupResultDto } from '../../Repository/eventbookyapi';
import { useAuth } from '../../Contexts/AuthContext';
import { TextService } from '../../Services/TextService';
import LeftMenu from '../Users/LeftMenu';
import { MemberService } from '../../Services/MemberService';
import LayoutLeftMenu from '../../Components/Layout/LayoutLeftMenu';
import { AddMultipleSpirisInvoicesForm } from '../../Components/Users/AddMultipleSpirisInvoices';

const AdminCreateSpirisInvoices = () => {
  const [groups, setGroups] = useState([] as WebApiServicesDataTransferObjectsGroupServiceGroupResultDto[]);
  const [memberResult, setMemberResult] = useState({} as WebApiMemberDtoMemberListResultDto);

  const { user } = useAuth();
  const GetText = TextService.GetText;

  useEffect(() => {
    GroupService.GetGroupsIncludingAllMembers().then(result => {

      result.forEach(element => {
        if (element.isDefaultGroup) {
          element.name = GetText("MemberList_DefaultAllMembersName");
        }
      });
      setGroups(result);
    });

    MemberService.GetAllMembers().then(result => {
      setMemberResult(result);
    });
  }, []);

  return <LayoutLeftMenu title={GetText("AdminCreateSpirisInvoices_Title")} menu={<LeftMenu selected={"sendEmail"} />}>
    <p style={{ maxWidth: 640, marginBottom: 24 }}>{GetText("AdminCreateSpirisInvoices_Description")}</p>
    <AddMultipleSpirisInvoicesForm user={user} groups={groups} memberResult={memberResult} />
  </LayoutLeftMenu>
};

export default AdminCreateSpirisInvoices;
